/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
ReactDOM.render(/*#__PURE__*/React.createElement(App, null), document.getElementById('root'));

// HMR
if (module.hot) {
  module.hot.accept();
}

// Axe
if (process.env.NODE_ENV !== 'production') {
  import('@axe-core/react').then(axe => {
    axe(React, ReactDOM, 1000);
  });
}